import { useState } from "react";
import { Menu, X, Phone, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/wa";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const links = [
  { id: "catalogo", label: "Catalogo" },
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "contatti", label: "Contatti" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#272A38]/80 bg-[#0B0C10]/80 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button
          data-testid="nav-brand-logo"
          onClick={() => scrollToId("top")}
          className="flex items-baseline gap-2"
        >
          <span className="font-display text-2xl font-black uppercase italic tracking-tight text-[#F3F4F6]">
            Delta
          </span>
          <span className="font-display text-2xl font-black uppercase italic tracking-tight text-[#F59E0B]">
            R.E.M.
          </span>
          <span className="mono hidden text-[10px] uppercase tracking-widest text-[#6B7280] sm:inline">
            Cremona
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex" data-testid="nav-links">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="mono text-xs uppercase tracking-widest text-[#9CA3AF] transition-colors duration-300 hover:text-[#F59E0B]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <a
            data-testid="nav-phone-link"
            href="tel:+393510741289"
            className="mono flex items-center gap-2 text-xs uppercase tracking-widest text-[#9CA3AF] transition-colors duration-300 hover:text-[#F3F4F6]"
          >
            <Phone className="h-3.5 w-3.5" /> 351 074 1289
          </a>
          <a
            data-testid="nav-contact-whatsapp"
            href={waLink("Salve Delta R.E.M., vorrei informazioni sui vostri motori.")}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[#25D366] px-4 py-2 font-display text-sm font-bold uppercase tracking-wide text-[#0B0C10] transition-colors duration-300 hover:bg-[#1EBE5B]"
          >
            <MessageCircle className="h-4 w-4" /> WhatsApp
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="text-[#F3F4F6] md:hidden"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#272A38] bg-[#0B0C10] px-4 py-4 md:hidden" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-link-${l.id}`}
              onClick={() => {
                setOpen(false);
                scrollToId(l.id);
              }}
              className="mono block w-full py-3 text-left text-sm uppercase tracking-widest text-[#9CA3AF]"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-mobile-whatsapp"
            href={waLink("Salve Delta R.E.M., vorrei informazioni sui vostri motori.")}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 flex items-center justify-center gap-2 bg-[#25D366] px-4 py-3 font-display text-sm font-bold uppercase tracking-wide text-[#0B0C10]"
          >
            <MessageCircle className="h-4 w-4" /> Scrivici su WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
